import EmptyProjects from "shared/EmptyProjects";
import ProjectDashboardCard from "./components/ProjectDashboardCard";

const Overview = ({ projectData }) => {
  const theme = ["bg-[#FF8F41]", "bg-[#61CE70]", "bg-[#0693E3]"];
  const donationType = ["cash", "volunteer", "items"];

  return (
    <div className="w-full h-full flex flex-wrap gap-5">
      {projectData.length === 0 || !projectData ? (
        <div className="w-full h-full flex-1 flex justify-center items-center">
          <EmptyProjects />
        </div>
      ) : (
        projectData?.map((donateCard, idx) => (
          <div key={donateCard._id} className="flex justify-center">
            <ProjectDashboardCard
              id={donateCard._id}
              cardImage={donateCard.project_picture}
              title={donateCard.name}
              createdAt={donateCard.createdAt.split("T")[0]}
              status={donateCard.status}
              donateTypes={donationType}
              amountRaised={donateCard.amountDonated}
              targetAmount={donateCard.fundraising_goal}
              bgColor={theme[idx % 3]}
              impact_of_donated_item={donateCard.impact_of_donated_item}
              impact_of_monetary_goal={donateCard.impact_of_monetary_goal}
              projected_impact={donateCard.projected_impact}
              summary={donateCard.summary}
              projectData={donateCard}
            />
          </div>
        ))
      )}
    </div>
  );
};

export default Overview;
